import "./YLongForm.scss";
import {
    ArrowRight,
    Code2,
    Laptop,
    Lightbulb,
    Rocket,
    Zap,
} from "lucide-react";
import {useTranslation} from "react-i18next";
import {DiscordMember, WorkItem} from "../../types";
import OurVideo from "../OurWorks/OurVideo/OurVideo";
import {discordUrl} from "../../Global";

const steps = [
    {
        id: "01",
        icon: Lightbulb,
    },
    {
        id: "02",
        icon: Laptop,
    },
    {
        id: "03",
        icon: Code2,
    },
    {
        id: "04",
        icon: Rocket,
    },
];

interface YVideoProps {
    staff: DiscordMember[] | [];
    workVideo: WorkItem[];
}

export default function YLongForm({ staff, workVideo }: YVideoProps) {
    const { t } = useTranslation();

    const roleIds = [
        '1425533293343932496',
        '1425533294061162507'
    ];

    const VYoutube = staff.filter((member) =>
        member.roles.some((role) => roleIds.includes(role.id))
    )

    return (
        <section className="graphics-minecraft">
            {/* ===== HERO ===== */}

            <div className="graphics-minecraft__hero">
                <div className="graphics-minecraft__hero-container">
                    {/* Left */}
                    <div className="graphics-minecraft__hero-content">
                        <h1 className="graphics-minecraft__title">
                            {t("youtube-long.title.up")}
                            <br />
                            {t("youtube-long.title.down")}<span>{t("youtube-long.title.bold")}</span>
                        </h1>
                        <p className="graphics-minecraft__description">
                            {t("youtube-long.subtitle")}
                        </p>
                        <div className="graphics-minecraft__actions">
                            <a href={discordUrl} target="_blank" className="graphics-minecraft__button" rel="noreferrer">
                                {t("youtube-long.preventive")}
                                <ArrowRight size={18} />
                            </a>
                            {workVideo.length > 0 && (
                                <a href="#portfolio" className="graphics-minecraft__button graphics-minecraft__button--secondary">
                                    {t("youtube-long.lookWorks")}
                                </a>
                            )}
                        </div>
                    </div>

                    {/*Presentation*/}
                </div>
            </div>

            {/* ===== STEP ===== */}
            <div className="graphics-minecraft__steps">
                <div className="graphics-minecraft__steps-container">
                    <header className="graphics-minecraft__steps-header">
                        <h2>{t(`youtube-long.develop.title`)}</h2>
                        <p>{t(`youtube-long.develop.subtitle`)}</p>
                    </header>

                    <div className="graphics-minecraft__steps-grid">
                        {steps.map((step, index) => {
                            const Icon = step.icon;
                            return (
                                <div className="graphics-minecraft__step" key={step.id}>
                                    <div className="graphics-minecraft__step-icon">
                                        <Icon size={24} />
                                    </div>
                                    <h3 className="graphics-minecraft__step-title">{t(`youtube-long.develop.card.${step.id}.title`)}</h3>
                                    <p className="graphics-minecraft__step-description">{t(`youtube-long.develop.card.${step.id}.subtitle`)}</p>
                                    {index < steps.length - 1 && (
                                        <div className="graphics-minecraft__step-connector">
                                            <Zap size={14} />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* ===== TEAM ===== */}
            {VYoutube.length > 0 && (
                <div className="graphics-minecraft__team">
                <div className="graphics-minecraft__team-container">
                    <header className="graphics-minecraft__team-header">
                        <h2>{t(`youtube-long.employees.title`)}</h2>
                        <p>{t(`youtube-long.employees.subtitle`)}</p>
                    </header>

                    <div className="graphics-minecraft__team-grid">
                        {VYoutube.map((dev) => (
                            <a
                                key={dev.id}
                                target="_blank"
                                href={dev.avatar}
                                rel="noopener noreferrer"
                                className="graphics-minecraft__team-card"
                            >
                                <div className="graphics-minecraft__team-avatar">
                                    <img src={dev.avatar} alt={dev.username} />
                                    <div className={`graphics-minecraft__team-status graphics-minecraft__team-status_${dev.online}`} />
                                </div>
                                <h3>{dev.username}</h3>
                                <span>Video Maker</span>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            )}

            {/* ===== PORTFOLIO ===== */}
            {workVideo.length > 0 && (
                <div className="graphics-minecraft__portfolio" id="portfolio">
                <div className="graphics-minecraft__portfolio-container">
                    <header className="graphics-minecraft__portfolio-header">
                        <h2>{t(`youtube-long.works.title`)}</h2>
                        <p>{t(`youtube-long.works.subtitle`)}</p>
                    </header>

                    <div className="video-short__portfolio-grid">
                        <OurVideo
                            title={false}
                            allWorkItems={workVideo}
                        />
                    </div>
                </div>
            </div>
            )}
        </section>
    );
}